/** Status do Termo LDPG da Pessoa */
export interface PessoaTermoLGPDStatus {
    id: number;
    nome: string;
    badge: string;
}

export const pessoaTermoLGPDStatusPendente: PessoaTermoLGPDStatus = {
    id: 1,
    nome: 'Pendente',
    badge: 'badge badge-pessoa-termo-lgpd-status badge-pessoa-termo-lgpd-status-pendente'
};
export const pessoaTermoLGPDStatusImpresso: PessoaTermoLGPDStatus = {
    id: 2,
    nome: 'Impresso',
    badge: 'badge badge-pessoa-termo-lgpd-status badge-pessoa-termo-lgpd-status-impresso'
};
export const pessoaTermoLGPDStatusAnexado: PessoaTermoLGPDStatus = {
    id: 3,
    nome: 'Anexado',
    badge: 'badge badge-pessoa-termo-lgpd-status badge-pessoa-termo-lgpd-status-anexado'
};

export const pessoaTermoLGPDStatuses: PessoaTermoLGPDStatus[] = [
    pessoaTermoLGPDStatusPendente,
    pessoaTermoLGPDStatusImpresso,
    pessoaTermoLGPDStatusAnexado
];

/** Verifica se o status do Termo LGPD da pessoa é Pendente */
export function isPessoaTermoLGPDStatusPendente(status: number): boolean {
    return status === pessoaTermoLGPDStatusPendente.id;
}

/** Verifica se o status do Termo LGPD da pessoa é Impresso */
export function isPessoaTermoLGPDStatusImpresso(status: number): boolean {
    return status === pessoaTermoLGPDStatusImpresso.id;
}

/** Verifica se o status do Termo LGPD da pessoa é Anexado */
export function isPessoaTermoLGPDStatusAnexado(status: number): boolean {
    return status === pessoaTermoLGPDStatusAnexado.id;
}
